import { useAxiosConfig } from '@shared/api/AxiosConfigProvider';
import { useGroupFoodAndDrinkList } from '@shared/api/lib/group/group';
import {
  GroupFoodAndDrinkListParams,
  PaginatedGroupFoodDrinkList,
} from '@shared/api/types';

/**
 * Cross-org Food and drink aggregation grouped by
 * `(item_type, name, external_id)`. Filters by `organizations` and an end-date
 * window via `dateStart`/`dateEnd`.
 *
 * The `enabled` option lets callers gate the query when sharing a single
 * component between this and the packaging endpoint.
 */
export const useGetGroupFoodAndDrink = (
  params?: GroupFoodAndDrinkListParams,
  options?: { enabled?: boolean }
) =>
  useGroupFoodAndDrinkList<PaginatedGroupFoodDrinkList>(params, {
    request: useAxiosConfig(),
    query: {
      // keepPreviousData: true,
      enabled: options?.enabled ?? true,
    },
  });
